// Module
var code = "<!DOCTYPE html> <html> <head> <meta charset=\"UTF-8\"/> <meta http-equiv=\"X-UA-Compatible\" content=\"IE=Edge\"/> <meta name=\"viewport\" content=\"width=device-width,initial-scale=1\"> <title>LiquidIP Add-in</title> {{SCRIPTS}} </head> <body class=\"bodyClass\"> {{INDEX}} </body> </html> ";
// Exports
export default code;